export default __webpack_public_path__ + "static/media/spelling_header.a758be6e.jpg";